import { PipeTransform, Pipe } from '@angular/core';

@Pipe({
  name: 'reverse',
  pure: true
})
export class ReversePipe implements PipeTransform {
  transform(array: any[] = []): any[] {
    return array ? array.slice().reverse() : [];
  }
}
